import React, { lazy, memo } from 'react';
import { CalendarIcon } from 'lucide-react';
const Story = () => {
  return <section className="py-16 md:py-24 bg-gradient-to-b from-white to-[#f8f9ff]" data-id="element-403">
      <div className="container mx-auto px-4 md:px-6" data-id="element-404">
        <div className="max-w-4xl mx-auto" data-id="element-405">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-406">
            <div className="p-8 md:p-12" data-id="element-407">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-[#1e293b] text-center" data-id="element-408">
                La historia de Sofía
              </h2>
              <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-409">
                <div className="md:w-1/3" data-id="element-410">
                  <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80" alt="Sofía" className="w-full h-auto rounded-lg shadow-md" width="400" height="600" loading="lazy" data-id="element-411" />
                </div>
                <div className="md:w-2/3" data-id="element-412">
                  <div className="flex items-center mb-4 bg-[#f0f9ff] p-3 rounded-lg" data-id="element-413">
                    <CalendarIcon size={24} className="text-[#3b82f6] mr-3" data-id="element-414" />
                    <p className="text-lg text-[#4a5568] font-medium" data-id="element-415">
                      Sofía calculó que en 2 años perdió 42 días de vida
                      productiva por culpa de sus migrañas.
                    </p>
                  </div>
                  <p className="text-lg text-[#4a5568] mb-4" data-id="element-416">
                    Días que pasó encerrada, cancelando planes, escapando de la
                    luz, ocultando el dolor.
                  </p>
                  <p className="text-lg text-[#4a5568] mb-4" data-id="element-417">
                    <span className="font-semibold" data-id="element-418">
                      Hasta que un día, encontró esto.
                    </span>{' '}
                    15 minutos de uso constante, y empezó a notar la diferencia.
                    Su cuerpo respondió. Su mente se liberó. Su tiempo regresó.
                  </p>
                </div>
              </div>
              <div className="text-center mt-8" data-id="element-419">
                <p className="text-xl text-[#4a5568] italic" data-id="element-420">
                  ✨ Si Sofía pudo... tú también puedes.
                </p>
              </div>
              <div className="mt-12 p-6 bg-gradient-to-r from-[#f8f9ff] to-[#eef2ff] rounded-xl border border-[#e2e8f0] transform transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-421">
                <h3 className="text-2xl font-semibold mb-4 text-[#1e293b] relative" data-id="element-422">
                  <span className="inline-block animate-pulse bg-yellow-100 px-2 -mx-2 rounded-md" data-id="element-423">
                    No estás comprando un producto.
                  </span>{' '}
                  <span className="relative" data-id="element-424">
                    Estás recuperando:
                    <span className="absolute -bottom-1 left-0 w-full h-1 bg-[#8b5cf6] rounded-full" data-id="element-425"></span>
                  </span>
                </h3>
                <ul className="space-y-2 text-lg text-[#4a5568]" data-id="element-426">
                  <li className="flex items-center transition-transform duration-200 hover:translate-x-1" data-id="element-427">
                    <span className="text-[#8b5cf6] mr-2 font-bold" data-id="element-428">•</span>
                    <span data-id="element-429">Tu enfoque.</span>
                  </li>
                  <li className="flex items-center transition-transform duration-200 hover:translate-x-1" data-id="element-430">
                    <span className="text-[#8b5cf6] mr-2 font-bold" data-id="element-431">•</span>
                    <span data-id="element-432">Tus horas de trabajo.</span>
                  </li>
                  <li className="flex items-center transition-transform duration-200 hover:translate-x-1" data-id="element-433">
                    <span className="text-[#8b5cf6] mr-2 font-bold" data-id="element-434">•</span>
                    <span data-id="element-435">Tus momentos importantes.</span>
                  </li>
                </ul>
                <p className="text-lg text-[#4a5568] mt-4 font-medium" data-id="element-436">
                  La diferencia entre tener 4 días de dolor al mes y tener 0...
                  es{' '}
                  <span className="text-[#8b5cf6] font-bold animate-pulse" data-id="element-437">
                    incalculable
                  </span>
                  . Hasta que lo vives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default memo(Story);